import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MenuIcon, XIcon, ShoppingCartIcon, UserIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const {
    user,
    isLoggedIn,
    logout
  } = useAuth();
  const [cartCount, setCartCount] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Update cart count when cart changes
  useEffect(() => {
    if (isLoggedIn && user) {
      const cart = JSON.parse(localStorage.getItem(`cart_${user.Email}`) || '[]');
      setCartCount(cart.length);
      // Setup event listener for cart changes
      const handleStorageChange = event => {
        if (event.key === `cart_${user.Email}` || !event.key) {
          const updatedCart = JSON.parse(localStorage.getItem(`cart_${user.Email}`) || '[]');
          setCartCount(updatedCart.length);
        }
      };
      window.addEventListener('storage', handleStorageChange);
      // Custom event for cart updates within the same window
      window.addEventListener('cartUpdated', handleStorageChange);
      return () => {
        window.removeEventListener('storage', handleStorageChange);
        window.removeEventListener('cartUpdated', handleStorageChange);
      };
    } else {
      setCartCount(0);
    }
  }, [user, isLoggedIn]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  return <nav className={`sticky top-0 z-40 w-full transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-amber-50'}`} data-id="element-140">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="flex justify-between h-16" data-id="element-142">
          <div className="flex items-center" data-id="element-143">
            <div className="flex-shrink-0 flex items-center" data-id="element-144">
              <Link to="/" className="text-lg sm:text-xl font-bold text-amber-800 truncate" data-id="element-145">
                Jose's Kare kare and Bulalo House
              </Link>
            </div>
          </div>
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-4 lg:space-x-8" data-id="element-146">
            <Link to="/" className="px-3 py-2 text-amber-900 hover:text-amber-700" data-id="element-147">
              Home
            </Link>
            <Link to="/menu" className="px-3 py-2 text-amber-900 hover:text-amber-700" data-id="element-148">
              Menu
            </Link>
            {isLoggedIn && <Link to="/orders" className="px-3 py-2 text-amber-900 hover:text-amber-700" data-id="element-149">
                Orders
              </Link>}
            {isLoggedIn && user && user.User_type === 'admin' && <Link to="/admin" className="px-3 py-2 text-amber-900 hover:text-amber-700" data-id="element-150">
                Admin Dashboard
              </Link>}
            <Link to="/about" className="px-3 py-2 text-amber-900 hover:text-amber-700" data-id="element-151">
              About
            </Link>
            <Link to="/contact" className="px-3 py-2 text-amber-900 hover:text-amber-700" data-id="element-152">
              Contact
            </Link>
          </div>
          <div className="flex items-center" data-id="element-153">
            {isLoggedIn ? <>
                <Link to="/customer" className="p-2 text-amber-900 hover:text-amber-700 relative" data-id="element-154">
                  <ShoppingCartIcon className="h-6 w-6" data-id="element-155" />
                  {cartCount > 0 && <span className="absolute top-0 right-0 bg-amber-800 text-white rounded-full h-5 w-5 flex items-center justify-center text-xs" data-id="element-156">
                      {cartCount}
                    </span>}
                </Link>
                <div className="ml-4 relative hidden md:block" data-id="element-157">
                  <div className="flex items-center space-x-4" data-id="element-158">
                    <Link to="/profile" className="p-2 text-amber-900 hover:text-amber-700" data-id="element-159">
                      <UserIcon className="h-6 w-6" data-id="element-160" />
                    </Link>
                    <button onClick={handleLogout} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-amber-800 hover:bg-amber-900" data-id="element-161">
                      Logout
                    </button>
                  </div>
                </div>
              </> : <div className="flex items-center space-x-4 hidden md:flex" data-id="element-162">
                <Link to="/login" className="px-4 py-2 text-sm font-medium text-amber-800 hover:text-amber-900" data-id="element-163">
                  Login
                </Link>
                <Link to="/register" className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-amber-800 hover:bg-amber-900" data-id="element-164">
                  Register
                </Link>
              </div>}
            <div className="ml-4 flex items-center md:hidden" data-id="element-165">
              <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-amber-900 hover:text-amber-700 focus:outline-none" aria-expanded="false" data-id="element-166">
                <span className="sr-only" data-id="element-167">Open main menu</span>
                {isMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-168" /> : <MenuIcon className="block h-6 w-6" data-id="element-169" />}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden`} data-id="element-170">
        <div className="pt-2 pb-3 space-y-1 bg-amber-50 shadow-lg" data-id="element-171">
          <Link to="/" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-172">
            Home
          </Link>
          <Link to="/menu" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-173">
            Menu
          </Link>
          {isLoggedIn && <Link to="/orders" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-174">
              Orders
            </Link>}
          {isLoggedIn && user && user.User_type === 'admin' && <Link to="/admin" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-175">
              Admin Dashboard
            </Link>}
          <Link to="/about" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-176">
            About
          </Link>
          <Link to="/contact" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-177">
            Contact
          </Link>
          {isLoggedIn ? <>
              <Link to="/profile" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-178">
                Profile
              </Link>
              <button onClick={() => {
            handleLogout();
            toggleMenu();
          }} className="block w-full text-left px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" data-id="element-179">
                Logout
              </button>
            </> : <>
              <Link to="/login" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-180">
                Login
              </Link>
              <Link to="/register" className="block px-3 py-2 text-base font-medium text-amber-900 hover:text-amber-700 border-l-4 border-transparent hover:border-amber-500" onClick={toggleMenu} data-id="element-181">
                Register
              </Link>
            </>}
        </div>
      </div>
    </nav>;
};
export default Navbar;